export default __webpack_public_path__ + "static/media/2.213380ae.JPG";